import React from 'react';
import brandLogo from '@/assets/led-logic-logo-128.png';
import brandLogo2x from '@/assets/led-logic-logo-256.png';

interface SiteLogoProps {
  className?: string;
  size?: 'sm' | 'md' | 'lg';
  onClick?: () => void;
}

// Pixel heights match the Tailwind size classes below. Width === height
// because the source logo is square.
const SIZE_PX: Record<NonNullable<SiteLogoProps['size']>, number> = {
  sm: 32,
  md: 48,
  lg: 64,
};

const SiteLogo: React.FC<SiteLogoProps> = ({ className = '', size = 'md', onClick }) => {
  const sizeClasses = {
    sm: 'h-8',
    md: 'h-12',
    lg: 'h-16',
  };
  const px = SIZE_PX[size];

  return (
    <div
      className={`flex items-center justify-center ${onClick ? 'cursor-pointer hover:opacity-80 transition-opacity' : ''} ${className}`}
      onClick={onClick}
    >
      <img
        src={brandLogo}
        srcSet={`${brandLogo} 1x, ${brandLogo2x} 2x`}
        alt="LED Logic"
        width={px}
        height={px}
        decoding="async"
        loading="eager"
        className={`${sizeClasses[size]} w-auto object-contain`}
      />
    </div>
  );
};

export default SiteLogo;
